import ContentPermissionsManager from './ContentPermissionsManager'
import pvfs from './pvfs'

class TemplatesPermissionsManager extends ContentPermissionsManager {
  canPublish() {
    return false
  }

  canDelete() {
    return this.isAdmin() || this.isCreator()
  }

  isReader() {
    return this.pvfs.includes(pvfs.TEMPLATE_VIEW)
  }

  isCreator() {
    return this.pvfs.includes(pvfs.TEMPLATE_CREATE)
  }

  isEditor() {
    return this.pvfs.includes(pvfs.TEMPLATE_EDIT)
  }
}

export default TemplatesPermissionsManager
